import React, { PropsWithChildren } from "react";

import ModalWithClearButton from "@src/sharedComponents/Modal/ModalWithClearButton";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./Container.module.css";

interface Props {
  title: string;
  closeModal: () => void;
}

const ModalContainer: React.FC<PropsWithChildren<Props>> = (props) => {
  return (
    <ModalWithClearButton
      className={styles.modal}
      closeModal={props.closeModal}
    >
      <Text className={styles.title} variant="title2">
        {props.title}
      </Text>

      {props.children}
    </ModalWithClearButton>
  );
};

export default ModalContainer;
